<template>
  <div class="pc-token-infos">
    <div class="head flex-left">
      <img :src="infos.icon" />
      <span>{{infos.symbol}}</span>
      <span v-if="infos.nickname">&nbsp;({{infos.nickname}})</span>
    </div>
    <div class="infos table-shadow">
      <h3 class="title">概况</h3>
      <div class="detail">
        <div class="item">
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/red.png" alt />
            <span class="item-title">发行总量</span>
            <span>{{(infos.total/100000000||'')|filterNum}}</span>
          </p>
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/blue.png" alt />
            <span class="item-title">持有人</span>
            <span>{{infos.holders}}</span>
          </p>
        </div>
        <div class="item">
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/red.png" alt />
            <span class="item-title">交易次数</span>
            <span>{{infos.txCount}}</span>
          </p>
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/blue.png" alt />
            <span class="item-title">发行时间</span>
            <span>{{infos.createdTime|formatTime}}</span>
          </p>
        </div>
        <div class="item">
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/red.png" alt />
            <span class="item-title">小数点</span>
            <span>8</span>
          </p>
          <p class="item-text flex-left">
            <img src="../../../assets/img/tip/blue.png" alt />
            <span class="item-title">价值</span>
            <span>￥{{Number(infos.rmb).toFixed(2)||0.00}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    infos: {
      type: Object,
      default: () => {
        return {
          icon: "",
          symbol: "",
          total: "",
          holders: "",
          txCount: "",
          createTime: "",
          ceilpoint: "",
          web: ""
        };
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.pc-token-infos {
  .head {
    margin: 30px 0 10px;
    font-size: 16px;
    color: $black;
    font-family: PingFangSC-Semibold;
    img {
      width: 30px;
      margin-right: 10px;
    }
  }
  .infos {
    width: 100%;
    background: $white;
    border-radius: 2px;
    border: 1px solid rgba(235, 239, 241, 1);
    .title {
      height: 70px;
      line-height: 70px;
      padding-left: 30px;
      font-size: 16px;
      color: $black;
      border-bottom: 1px solid #eee;
    }
    .detail {
      .item {
        display: inline-block;
        width: calc(1177px / 3);
        height: 100%;
        border-right: 1px solid #eee;
        padding: 10px 0 10px 30px;
        color: $black;
        font-size: 14px;
        .item-text {
          padding: 10px 0;
          .item-title {
            width: 96px;
            margin-left: 20px;
          }
        }
      }
      .item:last-child {
        border: none;
      }
    }
  }
}
</style>

